<p-toast></p-toast>
<p-confirmDialog [style]="{minWidth: '40vw'}" position="top" [baseZIndex]="10000" rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<div class="grid">
    <div class="col-12">
        <div class="card"> 
			<h5>Cobros por recuperador</h5>
            <hr>
            <form *ngIf="formGroup" [formGroup]="formGroup" (ngSubmit)="ejecutar()">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_desde">Fecha Desde</label>
                        <p-calendar id="fecha_desde" formControlName="fecha_desde" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="fecha_hasta">Fecha Hasta</label>
                        <p-calendar id="fecha_hasta" formControlName="fecha_hasta" dateFormat="dd/mm/yy"></p-calendar>
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="nombre_tarjeta">Nro Documento</label>
                        <input pInputText id="nro_documento" type="text" formControlName="nro_documento" />
                    </div>
                    <div class="field col-12 md:col-5">
                        <label for="usuarios">Usuarios:</label>
                        <p-multiSelect
                            [options]="usuarios"
                            optionLabel="nombre"
                            optionValue="nombre"
                            display="nombre"
                            formControlName="usuarios"
                            placeholder="Seleccione los usuarios"
                            [showToggleAll]="true"
                            display="chip"
                        ></p-multiSelect>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-2">
                        <button pButton pRipple type="submit" label="Ejecutar" icon="pi pi-check" class="p-button-info mr-2" pTooltip="Ejecutar"></button>
                    </div>
                    <ng-container *ngIf="items?.length">
                        <div class="col-12 md:col-2">
                            <p-splitButton 
                            label="Imprimir"  
                            [model]="opcionesImpresion" 
                            icon="pi pi-print"
                            styleClass="mi-splitbutton"
                            ></p-splitButton>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-success" label="Descargar" icon="pi pi-file-excel" (click)="descargarExcel()"></button>
                        </div>
                        <div class="col-12 md:col-2">
                            <button pButton pRipple class="p-button-info" label="Pantalla Completa" icon="pi pi-desktop" (click)="mostrarGraficoCompleto( true )"></button>
                        </div>
                    </ng-container>
                </div>
            </form>
            <hr>
                <div class="div-grafico" *ngIf="mostrarGrafico"  [ngStyle]="pantallaCompletaGrafico ? {'width': '100vw', 'height': '100vh', 'position': 'fixed', 'top': '0', 'left': '0', 'z-index': '9999','background-color':'white' } : {'width': 'auto', 'height': 'auto'}">
                    <div class="col-12" *ngIf="pantallaCompletaGrafico">
                        <button pButton pRipple class="p-button-info" label="Pantalla Normal" icon="pi pi-arrow-left" (click)="mostrarGraficoCompleto( false )"></button>
                    </div>
                    <div  id="chart-container" style="background-color: white;margin: auto;" class="col-12"
                    [ngStyle]="pantallaCompletaGrafico ? {'height': '70%' } : {'height': '500px'}">
                    </div>
                    <ng-container *ngIf="items?.length > 0">
                        <p-carousel 
                            [value]="items" 
                            [numVisible]="mostrarCantidadRecuperadores" 
                            [numScroll]="1" 
                            [circular]="true" 
                            [responsiveOptions]="responsiveOptions" 
                            autoplayInterval="10000">
                                <ng-template let-cobrador pTemplate="item">
                                    <div class="div-resumen-recuperador">
                                        <div class="resumen-recuperador" style="margin: 5px; max-width:500px;margin:auto;">
                                            <div class="div-icono-recuperador col-12">
                                                <i class="pi pi-user" style="font-size: 2rem;"></i>
                                                <h2 class="nombre-recuperador"> {{ cobrador.usuario }} </h2>
                                            </div>
                                            <div class="col-12 div-info-recuperador">
                                                Cobros por Pago Facil: {{ ( cobrador.totalImportePagoFacil | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}
                                                <br>
                                                Cobros por Entidad: {{ ( cobrador.totalImporteEntidad | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}
                                                <br>
                                                Total de Cobros: {{ ( cobrador.totalImporte | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                        </p-carousel>
                    </ng-container>
                </div>
            <hr>
            <p-table styleClass="p-datatable-sm p-datatable-gridlines" [value]="items" [loading]="loading" dataKey="usuario" responsiveLayout="scroll" rowHover="true"
                [showCurrentPageReport]="true" [paginator]="true" [rows]="20" currentPageReportTemplate="Mostrando {first} a {last} de {{items.length}} entradas">
                    <ng-template pTemplate="header">
                        <tr>
                            <th class="cabecera  align-center" style="max-width: 2rem"></th>
                            <th class="cabecera align-center" pSortableColumn="usuario">Usuario<p-sortIcon field="usuario"></p-sortIcon></th>
                            <th class="cabecera align-center" pSortableColumn="cantidadCobros">Cantidad de Cobros<p-sortIcon field="cantidadCobros"></p-sortIcon></th>
                            <th class="cabecera align-center" pSortableColumn="totalImportePagoFacil">Total de Importe - Pago Facil<p-sortIcon field="totalImportePagoFacil"></p-sortIcon></th>
                            <th class="cabecera align-center" pSortableColumn="totalImporteEntidad">Total de Importe - Entidad<p-sortIcon field="totalImporteEntidad"></p-sortIcon></th>
                            <th class="cabecera align-center" pSortableColumn="totalImporte">Total de Importe <p-sortIcon field="totalImporte"></p-sortIcon></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-item let-expanded="expanded">
                        <tr class="p-0 m-0">
                            <td style="max-width: 2rem" class="p-0 m-0">
                                <button type="button" pButton pRipple [pRowToggler]="item" class="p-button-sm p-button-text p-button-rounded" 
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
                            <td class="align-center"><b>{{ item.usuario  }}</b></td>
                            <td class="align-center">{{ item.cantidadCobros }}</td>
                            <td class="align-end">{{ ( item.totalImportePagoFacil | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                            <td class="align-end">{{ ( item.totalImporteEntidad | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                            <td class="align-end">{{ ( item.totalImporte | currency: '':'':'0.0':'es-PY' ) + ' Gs.' }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-item>
                        <tr>
                            <td colspan="12" class="pt-0">
                                <div class="pl-3 pr-3 pb-3">
                                    <p-table  #tabla [value]="item.detallesCobros" styleClass="p-datatable-sm p-datatable-gridlines" dataKey="id" responsiveLayout="scroll"
                                        [showCurrentPageReport]="true" [paginator]="true" [rows]="15"
                                        currentPageReportTemplate="Mostrando {first} a {last} de {{item.detallesCobros.length}} entradas">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th class="cabecera-detalle align-center" pSortableColumn="nro_documento">Nro Documento<p-sortIcon field="nro_documento"></p-sortIcon></th>
                                                <th class="cabecera-detalle align-center" pSortableColumn="fecha_cobro">Fecha de Cobro<p-sortIcon field="fecha_cobro"></p-sortIcon></th>
                                                <th class="cabecera-detalle align-center" pSortableColumn="tipo">Tipo<p-sortIcon field="tipo"></p-sortIcon></th>
                                                <th class="cabecera-detalle align-center" pSortableColumn="nombre_entidad">Entidad<p-sortIcon field="nombre_entidad"></p-sortIcon></th>
                                                <th class="cabecera-detalle align-center" pSortableColumn="nro_operacion">Nro Operacion<p-sortIcon field="nro_operacion"></p-sortIcon></th>
                                                <th class="cabecera-detalle align-center" pSortableColumn="importe_cobrado">Importe Cobrado<p-sortIcon field="importe_cobrado"></p-sortIcon></th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-detalle>    
                                            <tr>
                                                <td class="align-center">{{ detalle.nro_documento }} </td>
                                                <td class="align-center">{{ detalle.fecha_cobro | date: 'dd/MM/yyyy' }}</td>
                                                <td class="align-start">{{ detalle.tipo }}</td>
                                                <td class="align-start">{{ detalle.nombre_entidad }}</td>
                                                <td class="align-start">{{ detalle.nro_operacion }}</td>
                                                <td class="align-end">{{ ( detalle.importe_cobrado | currency: '':'':'0.0':'es-PY' ) }} Gs. </td>
                                            </tr>
                                        </ng-template>
                                    </p-table>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <tr>
                            <td class="cabecera-detalle align-center" colspan="2">TOTALES</td>
                            <td class="cabecera-detalle align-center">{{ totalCantidadCobros }}</td>
                            <td class="cabecera-detalle align-end">{{ totalCobrosPF | currency: '':'':'0.0':'es-PY' }} Gs.</td>
                            <td class="cabecera-detalle align-end">{{ totalCobrosEntidad | currency: '':'':'0.0':'es-PY' }} Gs.</td>
                            <td class="cabecera-detalle align-end">{{ totalCobros | currency: '':'':'0.0':'es-PY' }} Gs.</td>
                        </tr>
                    </ng-template>
                </p-table>
        </div>
    </div>
</div>

<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters"
(close)="cerrarOnLista($event)">
</app-on-lista>

